import React, { useRef } from "react";
import { Button } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { householdAction } from "../../../../actions";
import Loading from "../../../../components/Loading/Loading";
import { ConfirmDelete } from "../../../../components";

const RemoveHouseholdModal = ({ className, household }) => {
  const confirmDeleteRef = useRef();

  const { id, Portfolios } = household;
  const dispatch = useDispatch();

  const [isRequesting] = useSelector(({ household }) => [
    household.isRequesting,
  ]);

  const removeHousehold = (householdId) => {
    dispatch(householdAction.removeHouseholdById(householdId));
  };

  if (Portfolios.find((p) => p.onboardStatus !== "in-review")) {
    return null
  }

  return (
    <React.Fragment>
      {isRequesting && <Loading />}
      <ConfirmDelete
        dialogName="delete-household"
        dialogTitle="Confirm"
        dialogText="Are you sure you want to delete this household?"
        dialogConfirmedCallback={() => removeHousehold(id)}
        ref={confirmDeleteRef}
      >
        <Button
          variant="outlined"
          size="small"
          className={className}
          onClick={() => confirmDeleteRef.current.handleModalOpen()}
        >
          Remove Household
        </Button>
      </ConfirmDelete>
    </React.Fragment>
  );
};

export default RemoveHouseholdModal;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/RemoveHouseholdModal/index.jsx